import { TextField, TextFieldProps } from 'components'

import FormRow, { FormRowProps } from './FormRow'
import styles from './FormRow.module.scss'

type InputFormRowProps = FormRowProps & TextFieldProps

const TextFieldFormRow = ({
  className,
  description,
  mandatory,
  mode,
  title,
  ...inputProps
}: InputFormRowProps) => (
  <FormRow
    className={className}
    description={description}
    mandatory={mandatory}
    mode={mode}
    title={title}
  >
    <TextField className={styles.textfield} {...inputProps} />
  </FormRow>
)

export default TextFieldFormRow
